import { Link } from "react-router-dom";

import jamesImg from "../../../../assets/images/james.png";
import logoWhite from "../../../../assets/brand/logo-white.svg";
import { kanziSections } from "../../../../content/kanziSections";
import Reveal from "../../Reveal";
import Eyebrow from "../../Eyebrow";
import SpotlightCard from "../../SpotlightCard";

const Founder = () => (
  <section className="section-block">
    <div className="section-shell section-shell--wide">
      <Reveal>
        <SpotlightCard className="glass-panel kanzi-founder-card">
          <div className="kanzi-founder-card__inner">
            <div className="kanzi-founder-card__body">
              <Eyebrow>{kanziSections.founder.eyebrow}</Eyebrow>

              <div className="kanzi-founder-card__body-text">
                {kanziSections.founder.paragraphs.map((para, index) => (
                  <p
                    key={index}
                    className={
                      index === kanziSections.founder.paragraphs.length - 1
                        ? "kanzi-founder-card__closing"
                        : ""
                    }
                  >
                    {para}
                  </p>
                ))}
              </div>

              <div className="kanzi-founder-card__attribution">
                <div className="kanzi-founder-card__attribution-line" />
                <div>
                  <p className="kanzi-founder-card__name">
                    {kanziSections.founder.attribution}
                  </p>
                  <p className="kanzi-founder-card__bio">{kanziSections.founder.bio}</p>
                </div>
                <Link
                  to={kanziSections.founder.cta.href}
                  className="button button-secondary kanzi-founder-card__cta"
                  title="Schedule a discovery call with James"
                >
                  {kanziSections.founder.cta.label}
                </Link>
              </div>
            </div>

            <div className="kanzi-founder-card__mark">
              <img
                src={logoWhite}
                alt="Data Chimp Labs"
                className="kanzi-founder-card__logo"
                width="640"
                height="180"
              />
              <img
                src={jamesImg}
                alt="James, Founder of Data Chimp Labs"
                className="kanzi-founder-card__photo"
                width="2000"
                height="1580"
              />
            </div>
          </div>
        </SpotlightCard>
      </Reveal>
    </div>
  </section>
);

export default Founder;
